import Avatar from 'boring-avatars'
import { useEffect, useState } from 'react'

import { API } from '@/api'
import { EduVerify, EduVerifyStatus } from '@/models/profile'
import { useUserStore } from '@/stores/user'
import { formatDatePreset } from '@/utils/formatter'

export function ProfileHeaderCard() {
  const userStore = useUserStore()
  const [eduVerify, setEduVerify] = useState<EduVerify | undefined>(undefined)
  const profileTitle = userStore.nickname || userStore.alias
  const profileSubtitle = userStore.email || userStore.name

  useEffect(() => {
    API.getEduVerifyStatus().then((res) => {
      setEduVerify(res.eduVerify)
    })
  }, [])

  return (
    <div className="card overflow-clip bg-panel-white relative flex items-center gap-x-4">
      <div className="pointer-events-none absolute inset-0 bg-[url('@/assets/images/bg-account-assets.png')] bg-repeat bg-auto opacity-[0.08] invert dark:opacity-[0.22] dark:invert-0 [mask-image:linear-gradient(90deg,transparent_0%,black_44%,black_100%)] [-webkit-mask-image:linear-gradient(90deg,transparent_0%,black_44%,black_100%)]"></div>
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-panel-white via-panel-white/75 to-panel-white/0"></div>
      <div className="relative">
        <div className="text-primary flex flex-1 gap-x-4">
          <Avatar
            size={80}
            name={userStore.name.split('@')[0]}
            variant="beam"
            colors={['#525866']}
          />
          <div>
            <h6 className="mt-4 h6">{profileTitle}</h6>
            <div className="font-semibold text-sm">{profileSubtitle}</div>
          </div>
        </div>
        {eduVerify?.status === EduVerifyStatus.Verified && (
          <div className="flex gap-x-4 mt-4">
            <div className="flex p-2 bg-neutral-100 rounded-lg gap-x-2 t-x-m text-secondary">
              <div>Verified Identity</div>
              <div className="font-bold text-primary">Education</div>
            </div>
            <div className="flex p-2 bg-neutral-100 rounded-lg gap-x-2 t-x-m text-secondary">
              <div>Expiration Time</div>
              <div className="font-bold text-primary">
                {formatDatePreset((eduVerify.graduationTime?.seconds ?? 0) * 1000, 'day')}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
